
import {throwError as observableThrowError, of as observableOf, Observable} from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {Session} from './Session';
import {UrlService} from './UrlService';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {TaxplanIQServices} from "./TaxplanIQServices";
import {PATH, SOURCE_TYPE} from "../constants/Tpiq.constants";

declare let _: any;

export function getActiveTimerUrl(org, userId) {
  return `/TaxPlanningServices/orgs/${org}/users/${userId}/timeentry/start`;
}

export function getInvoiceMappedTasksUrl(org, userId, invoiceId) {
  return `/TaxPlanningServices/orgs/${org}/users/${userId}/invoices/${invoiceId}/tasks`;
}

export function getTaskMappedInvoicesUrl(org, userId, taskId) {
  return `/TaxPlanningServices/orgs/${org}/users/${userId}/tasks/${taskId}/invoices`;
}

export function getUserTimeCompositionUrl(org, userId, taskId) {
  return `/TaxPlanningServices/orgs/${org}/users/${userId}/tasks/${taskId}/invoices/timecomposition`;
}

export function getTaskStatusOrderUrl(org, userId, taskId, view) {
  return `/TaxPlanningServices/users/${userId}/orgs/${org}/tasks/${taskId}/rollstatus/${view}`;
}

export function getTasksWorkflows(org, userId){
  return `/TaxPlanningServices/orgs/${org}/users/${userId}/taskbuckets`;
}

export function getWorkflowsInTimeUrl(org, userId, clientId){
  return `/TaxPlanningServices/orgs/${org}/users/${userId}/taskbuckets/clients/${clientId}`;
}

export function getBulkUpdateInTasksUrl(userId, org){
  return `/TaxPlanningServices/users/${userId}/orgs/${org}/bulkUpdate`;
}

export function getAssignedWorkStatusUrl(orgId, userId, taskId){
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/taskbuckets/${taskId}/assigned-work`;
}

export function getAsigneesUsersUrl(userId, orgId){
  return `/TaxPlanningServices/org/${orgId}/users/${userId}/users/list`;
}

export function getTaskDashboardUrl(orgId, userId){
  return `/TaxPlanningServices/org/${orgId}/users/${userId}/tasks/list`;
}

export function getDeleteTaskUrl(orgId, userId, taskId){
  return `/TaxPlanningServices/org/${orgId}/users/${userId}/tasks/${taskId}`;
}

@Injectable({
  providedIn: 'root'
})
export class TasksService extends  TaxplanIQServices{

  allWorkflowsStatuses = {};
  allWorkflows: any;
  workflowsInTime: any = {};

  constructor(http: HttpClient) {
    super(http);
  }

  tasks(filter, index?): Observable<any> {
    let indexInc = index;
    if (index !== 0) {
      indexInc = index;
    }
    indexInc = indexInc.toString();
    let url = this.interpolateUrl(PATH.TASK_SERVICE, null, {id: Session.getUser().id});
    url = url + '?org=' + Session.getOrg() + '&date=' + filter.date + '&from=' + indexInc ;
    if (filter.status){
      url = url + '&status=' + filter.status;
    }
    if (filter.company){
      url = url + '&company=' + filter.company;
    }
    if (filter.assignees){
      url = url + '&assignees=' + filter.assignees;
    }
    if (filter.label){
      url = url + '&label=' + filter.label;
    }
    if (filter.type){
      url = url + '&type=' + filter.type;
    }
    if (filter.column){
      url = url + '&column=' + filter.column;
    }
    if (filter.order){
      url = url + '&order=' + filter.order;
    }
    if (filter.display){
      url = url + '&display=' + filter.display;
    }
    if (filter.searchKey){
      url = url + '&searchKey=' + filter.searchKey;
    }
    if (filter.sprintId){
      url = url + '&sprintId=' + filter.sprintId;
    }
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  clientTasks(filter, index?): Observable<any> {
    let indexInc = index;
    if (index !== 0) {
      indexInc = index;
    }
    indexInc = indexInc.toString();
    let url = getTaskDashboardUrl(Session.getOrg(), Session.getUser().id);
    url = url + '?date=' + filter.date + '&from=' + indexInc ;
    if (filter.status){
      url = url + '&status=' + filter.status;
    }
    if (filter.company){
      url = url + '&client=' + filter.company;
    }
    if (filter.assignees){
      url = url + '&assignees=' + filter.assignees;
    }
    if (filter.contacts){
      url = url + '&contacts=' + filter.contacts;
    }
    if (filter.label){
      url = url + '&label=' + filter.label;
    }
    if (filter.typeId){
      url = url + '&type=' + filter.typeId;
    }
    if (filter.column){
      url = url + '&column=' + filter.column;
    }
    if (filter.order){
      url = url + '&order=' + filter.order;
    }
    if (filter.display){
      url = url + '&display=' + filter.display;
    }
    if (filter.searchKey){
      url = url + '&searchKey=' + filter.searchKey;
    }
    if (filter.sprintId){
      url = url + '&sprintId=' + filter.sprintId;
    }
    if (filter.toDate){
      url = url + '&toDate=' + filter.toDate;
    }
    if (filter.fromDate){
      url = url + '&fromDate=' + filter.fromDate;
    }
    if (!_.isEmpty(filter.advSearchObj)){
      url = url + '&isActive=' + filter.advSearchObj.isActive;
      url = url + '&isDone=' + filter.advSearchObj.isDone;
      url = url + '&isNotStarted=' + filter.advSearchObj.isNotStarted;
      url = url + '&billed=' + filter.advSearchObj.billed;
      url = url + '&unbilled=' + filter.advSearchObj.unbilled;
      url = url + '&paid=' + filter.advSearchObj.paid;
      url = url + '&labels=' + filter.advSearchObj.labels;
    }
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  clientTasksByPost(filter, index?, clients?): Observable<any> {
    let indexInc = index;
    if (index !== 0) {
      indexInc = index;
    }
    indexInc = indexInc.toString();
    let url = getTaskDashboardUrl(Session.getOrg(), Session.getUser().id);
    url = url + '?date=' + filter.date + '&from=' + indexInc ;
    if (filter.status){
      url = url + '&status=' + filter.status;
    }
    if (filter.assignees){
      url = url + '&assignees=' + filter.assignees;
    }
    if (filter.contacts){
      url = url + '&contacts=' + filter.contacts;
    }
    if (filter.label){
      url = url + '&label=' + filter.label;
    }
    if (filter.typeId){
      url = url + '&type=' + filter.typeId;
    }
    if (filter.column){
      url = url + '&column=' + filter.column;
    }
    if (filter.order){
      url = url + '&order=' + filter.order;
    }
    if (filter.display){
      url = url + '&display=' + filter.display;
    }
    if (filter.searchKey){
      url = url + '&searchKey=' + filter.searchKey;
    }
    if (filter.sprintId){
      url = url + '&sprintId=' + filter.sprintId;
    }
    if (filter.toDate){
      url = url + '&toDate=' + filter.toDate;
    }
    if (filter.fromDate){
      url = url + '&fromDate=' + filter.fromDate;
    }
    if (!_.isEmpty(filter.advSearchObj)){
      url = url + '&isActive=' + filter.advSearchObj.isActive;
      url = url + '&isDone=' + filter.advSearchObj.isDone;
      url = url + '&isNotStarted=' + filter.advSearchObj.isNotStarted;
      url = url + '&billed=' + filter.advSearchObj.billed;
      url = url + '&unbilled=' + filter.advSearchObj.unbilled;
      url = url + '&paid=' + filter.advSearchObj.paid;
      url = url + '&labels=' + filter.advSearchObj.labels;
    }

    return this.create(url, clients || [], SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  clientExportTasks(filter, index?): string  {
    let indexInc = index;
    if (index !== 0) {
      indexInc = index;
    }
    indexInc = indexInc.toString();
    let rawUrl = this.interpolateUrl(PATH.CLIENT_TASK_SERVICE, null, {org: Session.getOrg(), id: Session.getUser().id});
    rawUrl += '?date=' + encodeURI(filter.date) + '&from=' + indexInc ;
    if (filter.status){
      rawUrl += '&status=' + encodeURI(filter.status);
    }
    if (filter.company){
      rawUrl += '&client=' + encodeURI(filter.company);
    }
    if (filter.assignees){
      rawUrl += '&assignees=' + encodeURI(filter.assignees);
    }
    if (filter.contacts){
      rawUrl += '&contacts=' + encodeURI(filter.contacts);
    }
    if (filter.label){
      rawUrl += '&label=' + encodeURI(filter.label);
    }
    if (filter.typeId){
      rawUrl += '&type=' + encodeURI(filter.typeId);
    }
    if (filter.column){
      rawUrl += '&column=' + encodeURI(filter.column);
    }
    if (filter.order){
      rawUrl += '&order=' + encodeURI(filter.order);
    }
    if (filter.display){
      rawUrl += '&display=' + encodeURI(filter.display);
    }
    if (filter.searchKey){
      rawUrl += '&searchKey=' + encodeURI(filter.searchKey);
    }
    if (filter.sprintId){
      rawUrl += '&sprintId=' + encodeURI(filter.sprintId);
    }
    if (filter.toDate){
      rawUrl += '&toDate=' + encodeURI(filter.toDate);
    }
    if (filter.fromDate){
      rawUrl += '&fromDate=' + encodeURI(filter.fromDate);
    }
    return rawUrl;
  }


  addTask(task): Observable<any> {
    const url = this.interpolateUrl(PATH.TASK_SERVICE, null, {id: Session.getUser().id});
    return this.create(url, task, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  updateTask(task): Observable<any> {
    const url = this.interpolateUrl(PATH.TASK_SERVICE, null, {id: Session.getUser().id});
    return this.update(url + '/' + task.id, task, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  removeTask(taskID, companyId): Observable<any> {
    const url = this.interpolateUrl(PATH.TASK_SERVICE, null, {id: Session.getUser().id});
    return this.delete(url + '/' + taskID, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  deleteTask(org, user , id): Observable<any> {
    const url = getDeleteTaskUrl(org, user, id);
    // const url = this.interpolateUrl(PATH.REMOVE_TASK_SERVICE, null, {userId: user, id});
    return this.delete(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getTask(taskID): Observable<any> {
    const url = this.interpolateUrl(PATH.TASK_SERVICE, null, {id: Session.getUser().id});
    return this.query(url + '/' + taskID, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getDocumentServiceUrl(): string {
    let url = this.interpolateUrl(PATH.USER_DOCUMENT_SERVICE, null, {id: Session.getUser().id});
    url = UrlService.getBaseUrl('DOCUMENT') + url;
    return url;
  }

  removeInvoiceAttachment(id): Observable<any> {
    const url = this.interpolateUrl(PATH.USER_DOCUMENT_TYPE_SERVICE, null, {id: Session.getUser().id});
    return this.delete(url + '/' + id, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getDocument(id): Observable<any> {
    const url = this.interpolateUrl(PATH.GET_DOCUMENT_TYPE_SERVICE, null, {id: Session.getUser().id});
    return this.query(url + '/' + id, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getHistoryTask(taskID): Observable<any> {
    const url = this.interpolateUrl(PATH.TASK_HISTORY_SERVICE, null, {taskId: taskID});
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getAssignees(): Observable<any> {
    const url = getAsigneesUsersUrl(Session.getUser('delegatedFrom').id, Session.getOrg());
    // const url = this.interpolateUrl(PATH.ASSIGNEES_SERVICE, null, {id: Session.getUser('delegatedFrom').id, org: Session.getOrg()});
    return this.create(url, {"fromIndex": -1}, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getAllBoards(): Observable<any> {
    const url = this.interpolateUrl(PATH.TASK_SERVICE, null, {id: Session.getUser().id});
    return this.query(url + '/boards?org=' + Session.getOrg(), SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  removeRecurring(taskID, dueDate, taskParentID?): Observable<any> {
    const url = this.interpolateUrl(PATH.TASK_SERVICE, null, {id: Session.getUser().id});
    return this.delete(url + '/' + taskID + '?recurredId=' + taskParentID + '&recurredDate=' + dueDate, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getTypeStatus(type): Observable<any> {
    let url = this.interpolateUrl(PATH.ORG_PREFERENCES, null, {org: Session.getOrg()});
    url = url + '/taskTypes/';
    return this.query(url + type, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  patchTaskStatus(taskID, status, data): Observable<any> {
    let url = this.interpolateUrl(PATH.TASK_SERVICE, null, {id: Session.getUser().id});
    url = url + '/' + taskID + '?status=' + status + '&org=' + Session.getOrg();
    return this.patch(url, data, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  activateClock(data): Observable<any> {
    const url = getActiveTimerUrl(Session.getOrg(), Session.getUser().id);
    return this.create(url, data, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  activateClockInTime(userId, data): Observable<any> {
    const url = getActiveTimerUrl(Session.getOrg(), userId);
    return this.create(url, data, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  updateTaskRow(task): Observable<any> {
    const url = `/TaxPlanningServices/org/${Session.getOrg()}/users/${Session.getUser().id}/tasks/${task.id}`;
    return this.update(url, task, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getInvoiceMappedTasks(org, userId, invoiceId, request): Observable<any> {
    const url = getInvoiceMappedTasksUrl(org, userId, invoiceId);
    return this.create(url, request, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getTaskMappedInvoices(org, userId, taskId, request): Observable<any> {
    const url = getTaskMappedInvoicesUrl(org, userId, taskId);
    return this.create(url, request, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getUserTimeComposition(org, userId, taskId, request): Observable<any> {
    const url = getUserTimeCompositionUrl(org, userId, taskId);
    return this.create(url, request, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  updateTaskStatusOrder(org, userId, taskId, view, data: any): Observable<any> {
    const url = getTaskStatusOrderUrl(org, userId, taskId, view);
    return this.update(url, data, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getWorkflowsForPosts(org, userId, type, id): Observable<any> {
    let  url = getTasksWorkflows(org, userId);
    if (type === 'companies') {
      url = `${url}?company_id=${id}`;
    } else if (type === 'clients') {
      url = `${url}?client_id=${id}`;
    }
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  clearWorkflowsCacheInTime(clientId) {
    this.workflowsInTime[clientId] = null;
  }

  getWorkflowsInTime(org, userId, clientId): Observable<any>  {
    if (this.workflowsInTime[clientId]) {
      return observableOf(this.workflowsInTime[clientId]);
    }
    const url = getWorkflowsInTimeUrl(org, userId, clientId);
    return this.query(url , SOURCE_TYPE.JAVA).pipe(map((res) => {
      this.workflowsInTime[clientId] = res;
      return this.workflowsInTime[clientId];
    }), catchError(this.handleError), );
  }

  bulkUpdateInTasks(userId, org, data): Observable<any>  {
    const url = getBulkUpdateInTasksUrl(userId, org);
    return this.update(url, data, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  assignedWorkStatus(orgId, userId, taskId, data): Observable<any>  {
    const url = getAssignedWorkStatusUrl(orgId, userId, taskId);
    return this.create(url, data, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    return observableThrowError(error.error);
  }
}
